/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";

export const Screen = styled.div`
    width: 100%;
    max-width: 420px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
`;

export const Headline = styled.h1`
    margin: 0;
    padding: 0;

    font-family: "Custora";
    font-weight: 400;
    font-size: 28px;
    line-height: 140%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #e9ecf5;
`;

export const Subhead = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 400;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #b7bdcb;
    font-size: 14px;
    line-height: 16.80px;
    word-wrap: break-word;
`;

export const EmailWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

export const Email = styled.span`
    color: #e9ecf5;
    font-size: 15px;
    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
    font-weight: 400;
    line-height: 22.50px;
    word-wrap: break-word;
`;

export const FullWidth = styled.div`
    width: 100%;
`;

export const PrimaryButton = styled.button`
    width: 100%;
    height: 48px;

    background: #5e84ed;
    border: none;
    border-radius: 10px;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 44.61px;
    letter-spacing: 0px;
    text-align: center;

    color: #ffffff;

    cursor: pointer;

    &:disabled {
        background: #2b2d33;
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export const ErrorText = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    text-align: center;

    color: #ff8a8a;
`;

export const SpinnerWrap = styled.div`
    margin-top: 12px;
    display: grid;
    place-items: center;
`;

export const CountdownLabel = styled.p`
    margin: 0;
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #b7bdcb;
    text-align: center;
`;

export const StatusLabel = styled.p<{ status: 'success' | 'error' }>`
  line-height: 15.60px;
  word-wrap: break-word;
    margin: 0;
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: ${({ status }) => (status === 'success' ? '#5E84ED' : '#D65F46')};
`;

export const CodeGlowWrap = styled.div<{ status: 'idle' | 'error' | 'success' }>`
    width: 100%;

    input {
        transition:
            box-shadow 0.18s ease-out,
            border-color 0.18s ease-out;
    }

    ${({ status }) =>
        status === 'success'
            ? `
        input {
          border-color: #5E84ED !important;
          box-shadow: 0 0 0 2px rgba(94, 132, 237, 0.28), 0 0 18px rgba(94, 132, 237, 0.22);
        }
      `
            : status === 'error'
              ? `
        input {
          border-color: #D64545 !important;
          box-shadow: 0 0 0 2px rgba(214, 69, 69, 0.28), 0 0 18px rgba(214, 69, 69, 0.22);
        }
      `
              : ``}
`;

export const Link = styled.span`
  color: #5E84ED;
  font-size: 15px;
  font-family: Inter;
  font-weight: 600;
  word-wrap: break-word;
`;